<template>
  <section class="listing">
    <div class="header">
      <div class="title">Financeiro</div>
      <button @click="print" class="button-save"><i class="fas fa-print"></i><span>Imprimir</span></button>
    </div>
    <form @submit.prevent class="form" style="padding: 0">
      <div class="form-search" style="padding: 0">
        <date-picker v-model="period" @change="getData" range placeholder="Selecione um período" format="DD/MM/YYYY"></date-picker>
        <div class="search-input">
          <input v-model="search" type="text" placeholder="Pesquisar..." />
          <i class="fas fa-search show-search"></i>
        </div>
      </div>
    </form>
    <div class="print-header">
      <div class="print-title">Financeiro</div>
    </div>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading" style="margin-top: 10px">
        <div class="sum-group">
          <div class="sum">
            <span>Total Bruto</span>
            <span>{{ gross.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</span>
          </div>
          <div class="sum">
            <span>Total Líquido</span>
            <span>{{ net.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</span>
          </div>
        </div>
        <div v-for="(group, i) in grouped" :key="`group-${i}`" class="group" :class="{ 'open' : open.includes(group.date) }">
          <div @click="open.includes(group.date) ? open = open.filter(x => x !== group.date) : open.push(group.date)" class="group-header">
            <i class="fas" :class="open.includes(group.date) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            <div class="group-date">{{ getDay(group.date) }} {{ getMonthText(group.date) }}</div>
            <div v-if="!open.includes(group.date)" class="group-total">{{ group.net.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}}</div>
            <div v-else class="group-total">
              <b>Recebíveis:</b> {{ group.items.length }} <br/>
              <b>Subtotal Bruto:</b> {{ group.gross.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }} <br/>
              <b>Subtotal Líquido:</b> {{ group.net.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}
            </div>
          </div>
          <div v-for="(x, index) in group.items" :key="`item-${index}`" class="list">
            <div class="time-text">
              <span>{{ getDay(x.date) }}</span>
              <span>/{{ getMonth(x.date) }}</span>
            </div>
            <div class="data">
              <div class="main-data">{{ x.customer || x.ticketName || '-' }}</div>
              <div class="detail-data">
                {{ x.tickets }} <i class="fas fa-ticket-alt"></i> | {{ x.paymentMethodText }}
                <span v-if="x.paymentMethod === 'card' && x.installment">({{ x.installment }}-{{ x.installments }})</span>
                <span v-else-if="x.paymentMethod === 'card'">({{ x.installments }}x)</span>
              </div>
            </div>
            <div style="text-align: right">
              <div class="main-data">{{ x.amountNet.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</div>
              <div class="detail-data">{{ x.amount.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import logger from '../../logger'
import { getAll } from '../api/financial'

export default {
  name: 'financial',
  data () {
    return {
      loading: true,
      data: [],
      period: [],
      search: '',
      open: []
    }
  },
  computed: {
    filtered () {
      return this.data
        .filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    },
    grouped () {
      return this.filtered.reduce((acc, cur) => {
        const found = acc.find(x => x.date === cur.receiveDate.split(' ')[0])
        if (found) {
          found.items.push(cur)
          found.gross += cur.amount || 0
          found.net += cur.amountNet || 0
        } else acc.push({ date: cur.receiveDate.split(' ')[0], items: [cur], gross: cur.amount || 0, net: cur.amountNet || 0 })
        return acc
      }, [])
    },
    gross () {
      return this.filtered.map(y => y.amount || 0).reduce((acc, cur) => acc + Number(cur), 0)
    },
    net () {
      return this.filtered.map(y => y.amountNet || 0).reduce((acc, cur) => acc + Number(cur), 0)
    }
  },
  async mounted () {
    try {
      const date = new Date()
      date.setMonth(date.getMonth() + 1)
      this.period = [new Date(), date]
      this.getData()
    } catch (error) {
      logger.error(error, this)
    }
  },
  methods: {
    async getData () {
      if (!this.period[0] || !this.period[1]) return false
      this.loading = true
      this.open = []
      try {
        const data = await getAll(this.period[0].toISOString().split('T')[0], this.period[1].toISOString().split('T')[0])
        this.data = data.map(x => {
          if (x.paymentMethod === 'card') x.paymentMethodText = 'Cartão de Crédito'
          else if (x.paymentMethod === 'billet') x.paymentMethodText = 'Boleto'
          else x.paymentMethodText = '-'
          return x
        })
      } catch (error) {
        logger.warn(error)
      }
      this.loading = false
    },
    print () {
      this.open = this.grouped.map(x => x.date)
      this.$nextTick(() => window.print())
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.group {
  margin: 5px 5px;
  border: 1px solid $secondary-color;
  border-radius: 5px;
  .group-header {
    display: flex;
    flex-wrap: wrap;
    color: $primary-color;
    padding: 10px 15px;
    cursor: pointer;
    .group-date {
      flex-grow: 1;
      font-weight: bold;
      padding: 0 10px;
    }
    .group-total {
      text-align: right;
      // font-weight: bold;
    }
  }
  .list {
    display: none;
  }
  &.open {
    padding-bottom: 5px;
    .group-header {
      border-bottom: 1px dashed #ccc;
    }
    .list {
      display: flex;
    }
  }
}

.calendar {
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  border-radius: 5px;
  margin-right: 10px;
  font-weight: 500;
  span:nth-child(1) {
    font-size: 1.2em;
  }
  span:nth-child(2) {
    font-size: 0.7em;
  }
}

.time-text {
  font-size: 2.2em;
  font-weight: 400;
  margin-right: 10px;
  color: #555;
  display: flex;
  span:nth-child(2) {
    font-size: 0.5em;
    line-height: 2em;
  }
}

.form-search {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;
  padding-bottom: 10px;

  input, select {
    width: 100%;
    height: 34px;
    margin: 5px !important;
  }

  .search-input {
    flex: 1;
    min-width: 200px;
    position: relative;
    input {
      width: calc(100% - 10px) !important;
    }
    i {
      position: absolute;
      top: 11px;
      right: 10px;
      color: #666;
      font-size: 1.5em;
    }
  }
}

.button-action:hover {
  i {
    animation-name: ticket-image !important;
    animation-duration: 0.5s !important;
    animation-iteration-count: 1 !important;
  }
}

.sum-group {
  display: flex;
  flex-wrap: wrap;
  .sum {
    display: flex;
    flex-basis: calc(100% - 10px);
    margin: 0 5px 10px;
    span {
      text-align: center;
      padding: 8px 0;
      flex-basis: 50%;
    }
    span:nth-child(1) {
      color: #fff;
      background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
      border-radius: 5px 0 0 5px;
      border: 1px solid $secondary-color;
    }
    span:nth-child(2) {
      font-weight: bold;
      color: $secondary-color;
      border-radius: 0 5px 5px 0;
      border: 1px solid $secondary-color;
    }
  }
  .sum2 {
    span:nth-child(1) {
      color: #555;
      background: #e5e5e5;
      border: 1px solid #555;
      border-right: none;
      font-weight: bold;
    }
    span:nth-child(2) {
      color: #555;
      border: 1px solid #555;
    }
  }
}

.print-header {
  display: none;
  justify-content: space-between;
  align-items: center;
  border-bottom: 5px solid $primary-color;
  padding: 20px 15px;
  margin-bottom: 20px !important;
}

.print-title {
  font-size: 2em;
  color: $primary-color;
  font-weight: 500;
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .sum-group {
    .sum {
      flex-basis: calc(50% - 10px);
    }
  }
  .form-search {
    input, select {
      width: auto;
    }
  }
}

@media print {
  .header, .form-search {
    display: none !important;
  }
  .print-header {
    display: block !important;
  }
  .sum-group {
    .sum {
      flex-basis: calc(50% - 10px);
    }
  }
  .list {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>

<style lang="scss">
.mx-datepicker {
  max-width: 230px;
  input {
    margin: 5px !important;
    width: calc(100% - 10px);
  }
  i {
    right: 15px;
  }
}
</style>
